import {
  HttpTransportType,
  HubConnectionBuilder,
} from '@microsoft/signalr';

import { SIM_HUB_ENDPOINT, SOCKET_ERR_MSG } from 'shared/constants';

const calculateIntervals = () => {
  const totalTimeinMins = 30;
  const intervalInSeconds = 5;

  const next = [];

  for (let i = 1; i <= (totalTimeinMins * 60 / intervalInSeconds); i++) {
    next.push(1000 * i * intervalInSeconds);
  }

  return next;
};


class SignalRMiddleware {
  constructor(host, url) {
    if (!host) throw new Error(SOCKET_ERR_MSG);
    if (!url) throw new Error(SOCKET_ERR_MSG);
    this.hubUrl = `${host}${SIM_HUB_ENDPOINT}${url}`;
  }

  openSocket = () => new HubConnectionBuilder()
    .withUrl(this.hubUrl, {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect(
      calculateIntervals(),
    )
    //.configureLogging(LogLevel.Trace)
    .build();
}

export default SignalRMiddleware;
